import { render, staticRenderFns } from "./DraftPriceCreateView.vue?vue&type=template&id=4170de8f&"
import script from "./DraftPriceCreateView.vue?vue&type=script&lang=js&"
export * from "./DraftPriceCreateView.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceCreateView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports